import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Admin from "./layouts/Admin";
import Auth from "./layouts/Auth";
import { Provider } from "react-redux";
import store from "./store/Store";
import ErrorBoundary from "components/ErrorBoundary";

const Login = lazy(() => import("views/auth/Login"));
const Dashboard = lazy(() => import("views/admin/Dashboard/Dashboard"));
const Festivals = lazy(() => import("views/admin/Settings/Festivals/Festivals"));
const Admins = lazy(() => import("views/admin/Accounting/Admins/Admins"));
const Roles = lazy(() => import("views/admin/Accounting/Roles/Roles"));
const RoleAdd = lazy(() => import("views/admin/Accounting/Roles/Add"));
const RoleEdit = lazy(() => import("views/admin/Accounting/Roles/Edit"));
const Presences = lazy(() => import("views/admin/Vote/Presences/Presences"));
const Votes = lazy(() => import("views/admin/Vote/Votes/Votes"));
const Cinemas = lazy(() => import("views/admin/Vote/Cinemas/Cinemas"));
const Movies = lazy(() => import("views/admin/Vote/Movies/Movies"));
const Halls = lazy(() => import("views/admin/Vote/Cinemas/Halls"));
const Sanses = lazy(() => import("views/admin/Vote/Cinemas/Sanses"));
const Schedules = lazy(() => import("views/admin/Vote/Schedules/Schedules"));
const Tickets = lazy(() => import("views/admin/Vote/Tickets/Tickets"));
const MovieVote = lazy(() => import("views/admin/Vote/Cinemas/MovieVote"));

const RouteLoading = () => (
  <div className="flex min-h-screen items-center justify-center" role="status" aria-live="polite">
    <div className="text-center text-gray-500">
      <span className="mx-auto mb-3 block h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-theme-1" />
      در حال بارگذاری…
    </div>
  </div>
);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Application root element was not found.");
}

createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <BrowserRouter>
          <Suspense fallback={<RouteLoading />}>
          <Routes>
          <Route path="/auth" exact element={<Auth />}>
            <Route path="/auth/login" exact element={<Login />} />
            <Route path="/auth" element={<Navigate to="/auth/login" />} />
          </Route>
          <Route path="/" exact element={<Admin />}>
            <Route path="/dashboard" exact element={<Dashboard />} />
            <Route path="/settings/festivals" exact element={<Festivals />} />
            <Route path="/accounting/admins" exact element={<Admins />} />

            <Route path="/accounting/roles" exact element={<Roles />} />
            <Route path="/accounting/roles/add" exact element={<RoleAdd />} />
            <Route
              path="/accounting/roles/edit/:id"
              exact
              element={<RoleEdit />}
            />
            {/* <Route path="/settings/general" exact element={<Generals />} /> */}
            <Route path="/vote/presences" exact element={<Presences />} />
            <Route path="/vote/votes" exact element={<Votes />} />
            <Route path="/vote/cinemas" exact element={<Cinemas />} />
            <Route path="/vote/movies" exact element={<Movies />} />
            <Route
              path="/vote/cinemas/:cinema_id/:cinema_name"
              exact
              element={<Cinemas />}
            />
            <Route
              path="/vote/cinemas/:cinema_id/halls/:hall_id/sanses/:hall_name"
              exact
              element={<Sanses />}
            />
            <Route
              path="/vote/cinemas/:cinema_id/halls/:cinema_name"
              exact
              element={<Halls />}
            />
            <Route
              path="/vote/schedules/:cinema_id"
              exact
              element={<Schedules />}
            />

            <Route
              path="/vote/tickets/:schedule_id"
              exact
              element={<Tickets />}
            />

            <Route
              path="/movies/vote/:cinema_id"
              exact
              element={<MovieVote />}
            />

            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
